import './surveySectionNumber.scss';
import React from 'react';
import SectionNumber, { IProps, IState } from '../../@sectionItem/sectionTypes/@sectionNumber/sectionNumber';
import { validSection } from '../../../../services/@pollService/pollService';

import {
    ESectionType,
    ESurveySectionType,
    ISectionBaseInfo,
    ISurveySectionInfo,
    ISectionOptionBaseInfo,
    ISurveyExtend,
    ISectionBaseResult,
    ISectionBaseExtend,
    ISectionBaseSetup,
} from '@umu/umu-types';

export class SurveySectionNumber extends SectionNumber<
    IProps<ESectionType, ISectionOptionBaseInfo, ISurveyExtend>,
    IState
> {
    public validSection(
        section: ISectionBaseInfo<ESurveySectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
        result: ISectionBaseResult<ESurveySectionType>,
    ) {
        return validSection(section as ISurveySectionInfo, result);
    }

    public render() {
        return <div className="section-item-body">{super.render()}</div>;
    }
}
